<script lang="ts">
  import { onMount } from 'svelte';
  import { getStr, validityEvent } from '../../../../common/util';
  import ExtraButton from '../../../common/components/ExtraButton.svelte';
  import Icon from '../../../common/components/Icon.svelte';
  import Text from '../../../common/components/Text.svelte';
  import { showSnackbar } from '../../../common/store/snackbar_store';
  import { submitReviewToServer } from '../../services/pdp-data-services';
  import { pdpTitleData } from '../../store/pdp_store';
  import Guidelines from './Guidelines.svelte';
  import ProsAndCons from './ProsAndCons.svelte';
  import StarRating from './StarRating.svelte';
  import ImageUpload from './ImageUpload.svelte';
  import ExtraProductTitle from '../ExtraProductTitle.svelte';

  export let open = true;
  export let productDetails;
  export let writeReviewFn = null;

  const defaultReviewFormData = {
    // external_id: "R001", // for updating old review
    order: {
      id: '',
      customer: {
        id: '',
        name: '',
        email: '',
      },
      item: {
        id: '',
        family_id: '',
      },
    },
    author: '',
    score: 0,
    // date: "2022-10-01",
    extract: '',
    pros: [],
    cons: [],
    images: [],
    // accepted: false,
  };

  $: if (open) {
    document.getElementsByTagName('html')[0].classList.add('overflow-hidden');
    resetForm();
  } else {
    document.getElementsByTagName('html')[0].classList.remove('overflow-hidden');
  }

  $: ({ amplienceProductBaseUrl } = productDetails);

  const reviewForm = Object.assign({}, defaultReviewFormData);
  let uploadItems = [];
  let isSubmitting = false;

  let userNameValid = false;
  let userEmailValid = false;
  let scoreValid = false;

  $: formValid = scoreValid && userNameValid && userEmailValid;
  $: reviewForm.images = uploadItems
    .filter(item => item.state === 'done' && item.imageData)
    .map(item => item.imageData);
  $: areImagesUploading = uploadItems.some(item => item.state === 'uploading');

  function resetForm() {
    reviewForm.order.customer.name = '';
    reviewForm.order.customer.email = '';
    reviewForm.pros = [];
    reviewForm.cons = [];
    reviewForm.extract = '';
    reviewForm.score = 0;
    reviewForm.images = [];
    uploadItems = [];

    userNameValid = false;
    userEmailValid = false;
    scoreValid = false;
  }
  async function submitReview() {
    if (isSubmitting || areImagesUploading) {
      return;
    }

    isSubmitting = true;
    reviewForm.author = reviewForm.order.customer.name;
    try {
      const response = await submitReviewToServer(reviewForm);
      const message =
        response.status === 200
          ? getStr('extra.pdp.review.submit.success.message')
          : getStr('extra.pdp.review.submit.error.message');

      showSnackbar(message, 'info');
      if (response.status === 200) {
        open = false;
      }
    } catch (error) {
      console.error('Failed to submit review', error);
      showSnackbar(getStr('extra.pdp.review.submit.error.message'), 'info');
    } finally {
      isSubmitting = false;
    }
  }

  onMount(() => {
    const { code, familyIdName } = productDetails;
    reviewForm.order.item.id = code;
    reviewForm.order.item.family_id = familyIdName;
  });

  const updateOpenFlag = () => {
    open = false;
    if (writeReviewFn !== null) {
      writeReviewFn();
    }
  };
</script>

<section class="write-review-container" class:open>
  <section class="product">
    <section class="close-btn" on:click={() => updateOpenFlag()}>
      <Icon type="font" glyph="close" desktopSize={32} mobileSize={24} />
    </section>
    <section class="image">
      <img src={amplienceProductBaseUrl} alt="product" />
    </section>
    <section class="info">
      <!-- <section class="title">
        <strong>{brandName}</strong>
        <span class="hide-on-mobile">.</span>
        {name}
      </section>
      <ProductPrice showDiscountUp={false} data={$productPriceData} /> -->
      <ExtraProductTitle data={$pdpTitleData} />
    </section>
  </section>
  <section class="review">
    <section class="rate-product">
      <div class="review-labels">
        <Text key="extra.pdp.review.rate.product" />
      </div>
      <section>
        <StarRating on:validityChange={e => (scoreValid = e.detail)} bind:rating={reviewForm.score} />
      </section>
    </section>
    <!-- <section class="rate-features">
            <section class="accordion-title" on:click={() => accordionExpanded = !accordionExpanded}>
                <h3><Text key="extra.pdp.review.rate.features" /></h3>
                <section class="icon" class:r-180={accordionExpanded}>
                    <Icon type="font" glyph="chevron_down" desktopSize={32} />
                </section>
            </section>
            {#if accordionExpanded}
            <section class="accordion-content" transition:slideIn={{ }}>
                <RateFeatureItem label="Longevity" />
                <RateFeatureItem label="Remote control" />
                <RateFeatureItem label="Flexibility" />
                <RateFeatureItem label="Leak proof" />
            </section>
            {/if}
        </section> -->
    <section class="add-written-review">
      <div class="review-labels">
        <Text key="extra.pdp.review.written.review" />
      </div>
      <textarea placeholder={getStr('extra.pdp.review..written.review.placeholder')} bind:value={reviewForm.extract} />
      <Guidelines />
    </section>
    <section class="pros-and-cons">
      <div class="review-labels">
        <Text key="extra.pdp.review.pros.cons" />
      </div>
      <section>
        <ProsAndCons type="pros" bind:itemList={reviewForm.pros} />
        <ProsAndCons type="cons" bind:itemList={reviewForm.cons} />
      </section>
    </section>

    <section class="add-photo-video">
      <div class="review-labels"><Text key="extra.pdp.review.add.photo.video" /></div>
      <p><Text key="extra.pdp.review.add.photo.video.subtitle" /></p>
      <section>
        <ImageUpload bind:uploadItems />
      </section>
    </section>
    <section class="your-email">
      <div class="review-labels">
        <Text key="extra.pdp.review.your.email" />
      </div>
      <p>
        <Text key="extra.pdp.review.your.email.subtitle" />
      </p>
      <fieldset>
        <label for="warPublicName">
          <Text key="extra.pdp.review.username.label" />
        </label>
        <input
          required
          placeholder={getStr('extra.pdp.review.username.placeholder')}
          id="warPublicName"
          type="text"
          use:validityEvent
          on:validityChange={e => (userNameValid = e.detail)}
          bind:value={reviewForm.order.customer.name}
        />
      </fieldset>
      <fieldset>
        <label for="warEmail">
          <Text key="extra.pdp.review.email.label" />
        </label>
        <input
          required
          placeholder={getStr('extra.pdp.review.email.placeholder')}
          id="warEmail"
          type="email"
          use:validityEvent
          on:validityChange={e => (userEmailValid = e.detail)}
          bind:value={reviewForm.order.customer.email}
        />
      </fieldset>
    </section>
  </section>
  <section class="submit">
    <ExtraButton variant="outlined" size="medium" color="primary" on:click={() => updateOpenFlag()}>
      {getStr('popup.cancel')}
    </ExtraButton>
    <ExtraButton
      variant="solid"
      color="primary"
      size="medium"
      disabled={!formValid || isSubmitting || areImagesUploading}
      on:click={submitReview}
    >
      {getStr('extra.pdp.review.submit')}
    </ExtraButton>
  </section>
</section>
<section class="backdrop" class:open on:click={() => (open = false)} />

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';

  .write-review-container {
    display: block;
    background-color: $primary-white;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    box-shadow: 0 0 10px rgba(0, 0, 0, 20%);
    overflow-y: auto;
    transition: transform 250ms ease;
    transform: translateX(100%);
    z-index: 101;

    @include desktop-min-width {
      left: unset;
      width: 43%;
    }

    &.open {
      transform: translateX(0);
    }

    .close-btn {
      color: $icon-only-icon-blue;
      position: absolute;
      top: 10px;
      right: 12px;
      @include desktop-min-width {
        top: 26px;
        right: 24px;
      }
    }
    .product {
      display: flex;
      gap: 12px;
      align-items: flex-start;
      background-color: $neutral-light-04;
      padding: 16px;
      @include desktop-min-width {
        padding: 45px 48px 24px 60px;
        gap: 36px;
      }

      .image {
        img {
          max-width: 100%;
          max-height: 90px;
          mix-blend-mode: darken;
        }
      }
      .info {
        max-width: 370px;

        :global {
          .product_title {
            background-color: transparent;
            display: flex;
            flex-direction: column;
            gap: 8px;
          }
        }

        & > section:not(:last-child) {
          padding-bottom: 12px;
          margin-top: 0;
          margin-bottom: 12px;
          margin-right: 36px;
          @include desktop-min-width {
            border-bottom: 1px solid $secondary-gray-02;
            margin-right: 0px;
          }
        }

        :global {
          .product_price {
            padding: 0;
            background-color: transparent;
            display: flex;
            flex-direction: column;
            gap: 6px;
          }
          .product_price__left {
            border-bottom: 1px solid $secondary-gray-02;
            width: 100%;
          }
          .product_price__right {
            width: 100%;
            padding-left: 0px;
          }
        }
        .title {
          padding-inline: 0;
          font-weight: 400;
          font-size: 16px;
          line-height: 18px;
          display: flex;
          flex-direction: column;
          gap: 4px;
          @include desktop-min-width {
            display: block;
          }
          strong {
            font-weight: 500;
          }
          span {
            transform: scale(2) translateY(-4px);
            display: inline-block;
          }
        }
        .price {
          .price-row {
            display: flex;
            gap: 6px;

            h3 {
              margin: 0;
            }
            .vat {
              font-weight: 400;
              font-size: 12px;
              line-height: 16px;
            }
            .old {
              font-weight: 400;
              font-size: 14px;
              line-height: 16px;
              color: $neutral-dark-04;
              text-decoration: line-through;
            }
          }
        }
      }
    }
    .review,
    .submit {
      padding-inline: 16px;

      @include desktop-min-width {
        padding-inline: 48px;
      }
    }
    .review {
      padding-top: 24px;
      padding-bottom: 24px;
      // border-bottom: 1px solid $secondary-gray-02;

      @include desktop-min-width {
        padding-top: 40px;
        padding-bottom: 48px;
      }

      & > section {
        .review-labels {
          margin: 0;
          font-weight: 500;
          font-size: 18px;
          line-height: 20px;

          @include desktop-min-width {
            font-weight: 700;
            font-size: 24px;
            line-height: 28px;
          }
        }
      }
      & > section:not(:last-child) {
        padding-bottom: 24px;
        margin-bottom: 24px;
        border-bottom: 1px solid $secondary-gray-02;
      }

      .rate-product > section {
        margin-top: 24px;
      }
      .rate-features {
        .accordion-title {
          display: flex;
          align-items: center;
          cursor: pointer;

          h3 {
            flex-grow: 1;
          }
          section.icon {
            transition: transform 250ms ease;

            &.r-180 {
              transform: rotateZ(-180deg);
            }
          }
        }
        .accordion-content {
          display: flex;
          gap: 16px;
          flex-wrap: wrap;
          justify-content: space-between;
          padding-top: 26px;
          overflow-y: hidden;

          & > :global(section) {
            flex-grow: 1;
          }
        }
      }
      .add-written-review {
        textarea {
          border: 1px solid $secondary-gray-02;
          width: 100%;
          margin-block: 8px;
          min-height: 120px;
          border-radius: 8px;
          padding: 16px;
          font-weight: 400;
          font-size: 14px;
          line-height: 16px;
          resize: none;
        }
      }
      .pros-and-cons {
        & > section {
          margin-top: 20px;
          display: flex;
          flex-direction: column;
          gap: 20px;
        }
      }
      .add-photo-video {
        & > section {
          overflow-x: auto;
          padding-top: 5px;
        }
      }
      .add-photo-video,
      .your-email {
        p {
          font-weight: 400;
          font-size: 14px;
          line-height: 16px;
          margin-bottom: 20px;
          margin-top: 8px;
        }
      }
      .your-email {
        fieldset {
          display: flex;
          gap: 8px;
          flex-direction: column;
          border: none;
          margin: 0;
          padding: 0;

          label {
            font-weight: 400;
            font-size: 12px;
            line-height: 14px;
            color: $neutral-dark-03;
          }
          input {
            font-weight: 400;
            font-size: 12px;
            line-height: 14px;
            padding: 16px;
            border-radius: 8px;
            border: 1px solid $neutral-dark-05;
          }

          & + fieldset {
            margin-top: 20px;
          }
        }
      }
    }
    .submit {
      padding-block: 24px;
      display: flex;
      justify-content: space-between;

      :global {
        button.mdc-button {
          padding: 15px 36px !important;
          min-height: 48px !important;
          flex-grow: 1;

          @include desktop-min-width {
            flex-grow: 0;
          }

          .mdc-button__label {
            font-weight: 700;
            font-size: 16px;
            line-height: 18px;
          }
        }
        .extra-btn-outlined--color-primary {
          min-width: 238px;
          @include desktop-max-width {
            min-width: 135px;
          }
        }
        .extra-btn-solid--color-primary {
          min-width: 262px;
          @include desktop-max-width {
            min-width: 192px;
          }
        }
      }
    }
  }

  .backdrop {
    position: fixed;
    display: none;
    inset: 0;
    background-color: rgba(0, 0, 0, 70%);
    z-index: 100;

    &.open {
      display: block;
    }
  }

  .add-photo-video {
    margin-top: 32px;
    .review-labels {
      font-weight: 700;
      font-size: 18px;
      margin-bottom: 8px;
    }
    p {
      font-size: 14px;
      color: $neutral-dark-04;
      margin-bottom: 16px;
    }
    .upload-box {
      display: flex;
      gap: 12px;
      flex-wrap: wrap;
      align-items: center;
      justify-content: flex-start;
    }
    .upload-label {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 88px;
      height: 88px;
      border: 2px dashed $secondary-gray-02;
      border-radius: 12px;
      cursor: pointer;
      background: $neutral-light-04;
      transition: border-color 0.2s;
    }
    .upload-label:hover {
      border-color: $neutral-light-02;
    }
    .plus-icon {
      font-size: 32px;
      color: $icon-only-icon-blue;
      font-weight: 400;
    }
  }
</style>
